import jwtDecode from "jwt-decode";
import { BehaviorSubject } from "rxjs";
import api, { IDataRequest, IDataResponse, STATUS_CODE } from "../../providers/api";
import { LocalStorage } from "../../commons/LocalStorage"
import { UserType } from "./login.types"
import { EmptyResponseException, InvalidException, ParameterRequiredException } from "src/framework/exceptions/Error";
import { appStore, Error } from "../AppStore";
import { ContaProvider } from "src/providers";
import { UrlUtil } from "src/framework/commons/UrlUtil";
import { SessionStorage, StringUtil } from "src/framework/commons";
import moment from "moment";
import { notifierStore } from "../NotifierStore";

export const isLoggedIn$ = new BehaviorSubject<boolean>(false);
export const userInfo$ = new BehaviorSubject<UserType | null>(null);
export const token$ = new BehaviorSubject<string | null>(null);

export const loginFromRedirect = async (token: string): Promise<void> => {
    const request: IDataRequest = {
        url: "/login/token/external",
        headers: {
            "Authorization": `Bearer ${token}`
        }
    }

    const response: IDataResponse = await api.post(request);

    if (response.statusCode === STATUS_CODE.OK) {
        const decodedToken: any = jwtDecode(response.data.token);
        const decodedTokenUser = decodedToken?.user || {};
        LocalStorage.set("solar.token", response.data.token);
        userInfo$.next(decodedTokenUser)
        LocalStorage.set("solar.userInfo", { ...decodedTokenUser, ...decodedToken.custom }, true);
        isLoggedIn$.next(true);
    }
}




export const validateLogin = (): string | null => {
    try {
        const token: string | null = LocalStorage.get("solar.token");

        // se encontar o token e ainda for valido faz o login persistido
        if (token) {
            token$.next(token)
            LocalStorage.set("solar.token", token);
            if (userInfo$.getValue() === null) {
                const decodedToken: any = jwtDecode(token);
                const decodedTokenUser = decodedToken?.user || {};
                userInfo$.next(decodedTokenUser)
                isLoggedIn$.next(true)
                LocalStorage.set("solar.userInfo", { ...decodedTokenUser, ...decodedToken.custom }, true);
                /*contaProvider.getDistribuidorRevendaUsuario().then((response) => {
                    parseExtraInfo(response)
                });*/
            }

        }
        return token;
    } catch (error) {
        //   localStorage.removeItem("solar.auth");
        //   localStorage.removeItem("solar.userInfo");
        return null;
    }
}

export const doLogin = async ({ username, password }: { username: string, password: string }): Promise<boolean> => {
    try {

        if (password === "" || username === "") {
            throw new ParameterRequiredException(
                "Usuário ou senha estão em branco"
            );
        }
        // efetua o login na pla
        const response: IDataResponse = await api.post({
            url: "/login",
            data: { username: username, password: password },
            headers: {
                Accpet: "*/*",
            },
        });

        if (response.statusCode === STATUS_CODE.BAD_REQUEST) {
            throw new InvalidException("Credenciais inválidas");
        }

        if (response.statusCode !== STATUS_CODE.OK) {
            if (response.statusCode === STATUS_CODE.INTERNAL_SERVER_ERROR) {
                throw new EmptyResponseException(
                    "Erro ao tentar efetuar o login, serviço indisponível"
                );
            }
        }

        if (Object.keys(response.data).indexOf("token") < 0) {
            throw new EmptyResponseException(
                "Erro ao tentar efetuar o login, sem resposta do serviço"
            );
        }
        // decode jwt
        const decodedToken: any = jwtDecode(response.data.token);
        token$.next(response.data.token)
        const decodedTokenUser = decodedToken?.user || {};
        LocalStorage.set("solar.token", response.data.token);

        userInfo$.next(decodedTokenUser)

        LocalStorage.set("solar.token", response.data.token);
        LocalStorage.set("solar.userInfo", { ...decodedTokenUser, ...decodedToken.custom }, true);

        // isLoggedIn$.next(true);

        /*contaProvider.getDistribuidorRevendaUsuario().then((response) => {
            if (response) {
                parseExtraInfo(response)
            }
        });*/

        return true;
    } catch (error: any) {
        let _error: Error = {
            error: "",
            code: error.code,
            message: error["message"],
        };
        appStore.setError(_error.message);
        return false;
    }
}

export const getUrlContaUnica = async (): Promise<string> => {
    try {
        const uri = `${window.location.origin}/`

        const baseUrl = `${process.env.REACT_APP_API_BASE_URL}`
        const _url = UrlUtil.generateUrl({ baseUrl: baseUrl, path: "/login/conta", searchParameters: { uri: uri } })
        const request: IDataRequest = {
            url: _url.relative,
        }
        const response: IDataResponse = await api.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data.redirect
        }
        return "";
    } catch (e) {
        return ""
    }
}


export const doLoginContaUnica = async (guid: string, session: string, fullPath: string, tipoCliente?: string): Promise<void> => {
    try {
        if (guid === "" || fullPath === "") {
            // gerar error
            return;
        }

        const data = {
            code: guid,
            uri: fullPath,
            session_state: session,
            tipoCliente,
        }

        const request: IDataRequest = {
            url: "/login/conta",
            data: data,
        }

        const response: IDataResponse = await api.post(request);

        if (response.statusCode === STATUS_CODE.OK) {

            const decodedToken: any = jwtDecode(response.data.token);
            const decodedTokenUser = decodedToken?.user || {};
            token$.next(response.data.token)
            LocalStorage.set("solar.token", response.data.token);

            userInfo$.next(decodedTokenUser)

            LocalStorage.set("solar.token", response.data.token);
            LocalStorage.set("solar.userInfo", { ...decodedTokenUser, ...decodedToken.custom }, true);

            isLoggedIn$.next(true);
        }

    } catch (error) {
        console.log(error)
    }
}


export const doLogOut = async (): Promise<string | null | undefined> => {
    let redirectURL: string | null | undefined = null
    try {
        const request: IDataRequest = {
            url: "/logout/conta",
            data: {
                redirect_uri: `${window.location.origin}/`
            }
        }

        const responseConta = await api.post(request);

        if (responseConta.statusCode !== STATUS_CODE.OK) {
            throw new InvalidException(responseConta.message)
        }
        redirectURL = responseConta?.data?.redirect_uri
    } catch (error) {

        const messages: string[] = error instanceof InvalidException ? [error.message] : [error as string]

        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: messages,
            onClose: () => notifierStore.setOpen(false),
            timeOut: 2500
        })

        notifierStore.setOpen(true)
    }

    if (!redirectURL) {
        LocalStorage.removeAll();
        SessionStorage.removeAll();
        isLoggedIn$.next(false);
    }

    return redirectURL;
}

export const getUserExtraData = () => {
    if (userInfo$.getValue()?.userId) {
        /*contaProvider.getDistribuidorRevendaUsuario().then((response) => {
            parseExtraInfo(response)
        });*/
    }
}

export const parseExtraInfo = (response: any) => {
    if (response) {
        const userInfo: any = {
            ...userInfo$.getValue(),
            ...response,
            isIntelbras: response.distribuidor_id === null && response.revenda_id === null,
            isDistribuidor: response.distribuidor_id !== null && response.revenda_id === null,
            isRevenda: response.distribuidor_id !== null && response.revenda_id !== null,
        }

        LocalStorage.set("solar.userExtraInfo", userInfo, true)
    }
} 
